import { DpFanSports, DpFanStagesStateTeams, DpFanTeams } from '@/data/Content/DpFan/types';

// Sports are children of the "Zona Fan" node, so the selection itself must be
// persisted as { parentId: zonaFanId, children: [sportIds] } — mirroring how
// brands persist under the "Marcas" node. Without this, leaf categories
// (Casual, Relojes, …) are never saved and no sport is read back as selected.
export const generateDpFanSelectedSportsBody = (
	selectedSports: string[],
	sports: DpFanSports
): { parentId: number; children: number[] }[] => {
	const zonaFanId = sports.at(0)?.parentId;

	if (!zonaFanId) {
		return [];
	}

	const children = sports
		.filter((sport) => selectedSports.includes(sport.name))
		.map((sport) => sport.id);

	return [{ parentId: zonaFanId, children }];
};

export const generateDpFanUpdateTeamsBody = (
	selectedTeams: DpFanStagesStateTeams,
	sports: DpFanSports,
	teams: DpFanTeams
): { parentId: number; children: number[] }[] =>
	sports.flatMap((_sport) => {
		const catalog = teams?.[_sport.name] ?? [];
		const selectedNames = selectedTeams?.[_sport.name] ?? [];

		const byParent = catalog.reduce((acc, item) => {
			if (item.parentId == null) {
				return acc;
			}

			const group = acc.get(item.parentId) ?? [];

			if (selectedNames.includes(item.name)) {
				group.push(item.id);
			}

			acc.set(item.parentId, group);
			return acc;
		}, new Map<number, number[]>());

		return Array.from(byParent.entries()).map(([parentId, children]) => ({
			parentId,
			children,
		}));
	});

export const generateDpFanUpdateBody = ({
	selectedSports = [],
	selectedTeams = {},
	selectedBrands = [],
	sports = [],
	teams = {},
	brands = [],
}: {
	selectedSports?: string[];
	selectedTeams?: DpFanStagesStateTeams;
	selectedBrands?: string[];
	sports?: DpFanSports;
	teams?: DpFanTeams;
	brands?: DpFanSports;
}): { parentId: number; children: number[] }[] => {
	const payload: { parentId: number; children: number[] }[] = [];

	payload.push(...generateDpFanSelectedSportsBody(selectedSports, sports));

	const brandsIds =
		brands?.filter((brand) => selectedBrands?.includes(brand.name)).map((brand) => brand.id) ?? [];

	const parentId = brands.at(0)?.parentId;
	if (parentId) {
		payload.push({
			parentId,
			children: brandsIds,
		});
	}

	const teamsIds = generateDpFanUpdateTeamsBody(selectedTeams, sports, teams);

	if (teamsIds.length > 0) {
		payload.push(...teamsIds);
	}

	return payload;
};
